module.exports = __webpack_public_path__ + "img/c99.601e1dbf.png";